import gql from "graphql-tag";
import { useQuery } from '@apollo/react-hooks';
import { formatDateForQuery, convertDateToShowHowManyDaysAgoSinceToday, cleanProjectDataForFrontEnd } from './helperFunctions';
import { hasuraClient } from '../../hasura';
import { matrakUserIds } from './matrakUserIds';
const todaysDate = new Date();
const lastWeek = formatDateForQuery(todaysDate, 'lastWeek');
const lastMonth = formatDateForQuery(todaysDate, 'lastMonth');

export const GET_PROJECT = gql`
  query allProjects($lastWeek: Date) {
    allProjects(filter: { classification__in: ["VIP", "self-service"] }) {
      id
      name
      classification
      start_date
      end_date
      numberOfAdmins
      numberOfEndUsers
      numberOfCompaniesOnProject
      adminHasInAppNotifications
      numberofDefectReportAdminCreated
      adminHasCustomReportsSetup
      reports {
        name
      }
      adminWeeklyReport: users(filter: { user_reports_last_sent__gt: $lastWeek }) {
        username
      }
      user_last_login: users { user_id: id, username, companyname, last_login }
    }

    allCompanies(filter: { projects: { classification__in: ["vip", "self-service"] }, ids__nin: [1, 11]}) {
      id
      name
      company_trade
      projects {
        id
      }
      users {
        id
        projectAccess {
            project {
                id
            }
            level
            has_accessed
            has_accessed_date
            last_accessed_date
        }
      }
    }
  }
`;

const USER_ACTIVITY = gql`
  query MyQuery($projectIds: [bigint!], $matrakUserIds: [String!], $lastWeek: timestamptz, $lastMonth: timestamptz) {
    weekly_activity: website_prod_pages(where: {project_id: {_in: $projectIds}, timestamp: {_gte: $lastWeek}, user_id: {_nin: $matrakUserIds}}, order_by: {project_id: desc, timestamp: desc}, distinct_on: project_id) {
      user_id
      timestamp
      project_id
      project_name
    }

    monthly_activity: website_prod_pages(where: {project_id: {_in: $projectIds}, timestamp: {_gte: $lastMonth}, user_id: {_nin: $matrakUserIds}}, order_by: {project_id: desc, timestamp: desc}, distinct_on: project_id) {
      user_id
      timestamp
      project_id
      project_name
    }
  }
`;

// Call Hasura to retrieve user "login" info for each Project
// This is used to find users last "Page load" and determine if they have logged in
// FYI: This will be removed in favour of the new last_accessed info from users_access table
export const HasuraClientLoginDataCall = async (arrayOfProjectIds) => {
  // const { loading: userLoading, error: userError, data: userData } = await hasuraClient.query({
  //   query: USER_ACTIVITY,
  //   variables: {
  //     projectIds: arrayOfProjectIds,
  //     lastWeek: lastWeek,
  //     lastMonth: lastMonth,
  //     matrakUserIds: matrakUserIds
  //   },
  //   client: hasuraClient,
  // });
  //
  // if (userError) console.log('Hasura error: ', userError);
  // if (userLoading) console.log('Hasura data is loading');
  // if (userData) {
  //   return userData;
  // }
};

export const RetrieveProjectDataFromGraphQL = props => {
  let { loading: projectLoading, error: projectError, data: projectData } = useQuery(GET_PROJECT, {
    variables: { id: parseInt(props.id), lastWeek },
  });

  if (projectError) console.log(projectError);
  if (projectLoading) console.log('RetrieveProjectDataFromGraphQL: Data is loading');
  if (projectData) {
    projectData = cleanProjectDataForFrontEnd(projectData);
    console.info('RetrieveProjectDataFromGraphQL: Data loaded');
  }
  return projectData;
};

// Match user login info to Project and check weekly/monthly activity
// based on last Page Load, update projectData object
export const matchUserLoginInfoToProject = (allUsersLastLogin, projectData) => {
  allUsersLastLogin.weekly_activity.forEach(userProject => {
    let targetProject = projectData.allProjects.findIndex(project => project.id === userProject.project_id)
    const lastLoginWithinTheWeek = convertDateToShowHowManyDaysAgoSinceToday(userProject.timestamp);
    projectData.allProjects[targetProject].userLoggedInLastWeek = lastLoginWithinTheWeek;
  });

  allUsersLastLogin.monthly_activity.forEach(userProject => {
    let targetProject = projectData.allProjects.findIndex(project => project.id === userProject.project_id)
    const lastLoginWithinTheMonth = convertDateToShowHowManyDaysAgoSinceToday(userProject.timestamp);
    projectData.allProjects[targetProject].userLoggedInLastMonth = lastLoginWithinTheMonth;
  });
  // If a user has not logged in recently, show false
  projectData.allProjects.forEach(project => {
    if (!project.userLoggedInLastMonth) {
      project.userLoggedInLastMonth = 'False'
    }
    if (!project.userLoggedInLastWeek) {
      project.userLoggedInLastWeek = 'False'
    }
    // Match last Month login with last Week login
    if (project.userLoggedInLastWeek !== 'False') {
      project.userLoggedInLastMonth = project.userLoggedInLastWeek;
    }
  });
  return projectData;
};
